export default "__VITE_ASSET__DbCNQP9U__"